/* eslint-disable no-lone-blocks */
/* eslint-disable no-mixed-operators */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useTranslate, useTranslateDispatch } from "../../translate";
import Switch from "@ingka/switch";
import {
  LoadingIconContainer,
  SheetModalContainer,
} from "@afg-ikea/ikea-kiosk-related-components/dist/exports";
import CheckGiftCardBalanceModalBody from "../../Components/CheckGiftCardBalanceModalBody";
import TrackOrderModalBody from "../../Components/TrackOrderModalBody";
import ClickAndCollectOrderModalBody from "../../Components/ClickAndCollectOrderModalBody";
import VoiceableServiceModalBody from "../../Components/VoiceableServiceModalBody";
import { getCountryCode } from "../../util/utils";

import "@ingka/grid/style.scss";
import GridCard from "../../Components/GridCard";
import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/aspect-ratio-box/style.scss";
import "@ingka/image/style.scss";
import "@ingka/card/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/switch/style.scss";
import "./Home.scss";
import ServiceToHelp from "../../Components/ServiceToHelp/ServiceToHelp";
import { useDispatch, useSelector } from "react-redux";
import { fetchUIConfig } from "../../redux/uiConfig/uiConfigAction";

import Constants from "../../Constants";
import {
  resetCNCManualWeborderStatus,
  resetCNCScannedWeborderStatus,
} from "../../redux/cncWebOrder/cncWebOrderActions";

const Home = ({ medium, source, locale, mode }) => {
  const i18n = useTranslate();
  const { t, isRtl, getCurrentLanguageCode } = i18n;
  const translationDispatch = useTranslateDispatch();
  const dispatch = useDispatch();
  var ikeaLogo = require(`../../images/ikea-logo.png`);
  const loading = useSelector(
    ({ loadingIndicator }) => loadingIndicator.loading
  );

  const currentLanguageCode = getCurrentLanguageCode();
  const homeConfig = useSelector(({ uiConfig }) => uiConfig?.config ?? []);

  const normalConfigs =
    homeConfig &&
    homeConfig.filter((item) => item.type === "normal" && item?.show);

  function setCountryCodeToLocalStorage() {
    const countryCode = getCountryCode(locale);
    localStorage.countryCode = countryCode;
  }
  useEffect(() => {
    translationDispatch({
      type: "CHANGE_LANGUAGE",
      language: locale,
    });
    setCountryCodeToLocalStorage();

    getCurrentLanguageCode();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  useEffect(() => {
    dispatch(fetchUIConfig());
  }, [mode]);

  setCountryCodeToLocalStorage();
  const initialSheetModalState = { visible: false, children: null };
  const [sheetModalState, setSheetModalState] = useState(
    initialSheetModalState
  );
  const checkGiftCardBalanceCardClick = () => {
    const checkGiftCardBalanceModalBody = <CheckGiftCardBalanceModalBody />;
    setSheetModalState({
      visible: true,
      children: checkGiftCardBalanceModalBody,
    });
  };
  const TrackOrderCardClick = () => {
    const trackOrderModalBody = <TrackOrderModalBody />;
    setSheetModalState({
      visible: true,
      children: trackOrderModalBody,
    });
  };

  const handleClickAndCollectOrderClick = () => {
    const clickAndCollectOrderModalBody = (
      <ClickAndCollectOrderModalBody mode={mode} />
    );
    setSheetModalState({
      visible: true,
      children: clickAndCollectOrderModalBody,
    });
  };

  const handleSheetModalClose = () => {
    setSheetModalState(initialSheetModalState);
    dispatch(resetCNCManualWeborderStatus());
    dispatch(resetCNCScannedWeborderStatus());
  };
  const enableArabicSwitchChanged = (e) => {
    let localeCode = e.target.checked
      ? Constants.QA.arlocaleCode
      : Constants.QA.enlocaleCode;
    translationDispatch({
      type: "CHANGE_LANGUAGE",
      language: localeCode,
    });
    setCountryCodeToLocalStorage();
  };

  useEffect(() => {
    if (homeConfig) {
      const url = window.location.href;
      if (url.search("#checkGiftCardBalanceCard") >= 0) {
        checkGiftCardBalanceCardClick();
      } else if (url.search("#trackYourOrder") >= 0) {
        TrackOrderCardClick();
      } else if (url.search("#clickAndCollectOrder") >= 0) {
        handleClickAndCollectOrderClick();
      }
    }
  }, [homeConfig]);

  const handleVoiceableServiceClick = () => {
    const voiceableServiceModalBody = <VoiceableServiceModalBody mode={mode} />;
    setSheetModalState({
      visible: true,
      children: voiceableServiceModalBody,
    });
  };

  const itemClickHandler = (item) => {
    const name = item?.name;
    var onClickCallback = () => console.error("Click item handler not defined");
    switch (name) {
      case Constants.menuItemType.CheckGiftCardBalance:
        onClickCallback = checkGiftCardBalanceCardClick;
        break;
      case Constants.menuItemType.TrackYourOrder:
        onClickCallback = TrackOrderCardClick;
        break;
      case Constants.menuItemType.ClickAndCollectOrder:
        onClickCallback = handleClickAndCollectOrderClick;
        break;
      case Constants.menuItemType.VoiceableService:
        onClickCallback = handleVoiceableServiceClick;
        break;
      default:
        break;
    }
    return onClickCallback;
  };

  return (
    <div className="home-container">
      <div className="sst-header-bar" dir="ltr">
        {mode === Constants.modeType.kiosk && (
          <div>
            <img alt="logo" src={ikeaLogo} />
          </div>
        )}
        {mode === Constants.modeType.kiosk && (
          <div className="sst-header-bar--switch-comp-container">
            <div className="sst-header-bar--switch-comp-container-label">
              {t("home.switch.arTitle")}
            </div>
            <Switch onChange={enableArabicSwitchChanged} />
          </div>
        )}
      </div>
      {Array.isArray(normalConfigs) && (
        <div className="normal-items">
          {normalConfigs.map((secConf, index) => {
            if (
              (mode === Constants.modeType.kiosk && !secConf?.showInKiosk) ||
              (mode !== Constants.modeType.kiosk && !secConf?.showInWeb)
            ) {
              return <></>;
            }

            return (
              <div className="normal-item" key={index}>
                {((mode === Constants.modeType.kiosk &&
                  secConf?.showTitleKiosk) ||
                  (mode !== Constants.modeType.kiosk &&
                    secConf?.showTitleWeb)) && (
                  <div className="home-container--title">
                    {secConf?.[currentLanguageCode]?.title}
                  </div>
                )}
                <div className="grid-container primary-items">
                  {secConf?.menuItems &&
                    secConf?.menuItems.map((item, kindex) => {
                      if (!item?.visible) return <></>;

                      if (
                        (mode === Constants.modeType.kiosk &&
                          !item?.showInKiosk) ||
                        (mode !== Constants.modeType.kiosk && !item?.showInWeb)
                      ) {
                        return <></>;
                      }

                      return (
                        <div
                          className="grid-item"
                          dir={isRtl() ? "rtl" : "ltr"}
                          key={kindex}
                        >
                          <GridCard
                            title={item?.[currentLanguageCode]?.title}
                            icon={item?.icon?.data?.full_url}
                            onClick={itemClickHandler(item)}
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
        </div>
      )}
      <ServiceToHelp mode={mode} />
      <SheetModalContainer
        visible={sheetModalState.visible}
        onClose={handleSheetModalClose}
      >
        {sheetModalState.children}
      </SheetModalContainer>
      {loading && (
        <div className="lding-continer">
          <LoadingIconContainer locale={locale} />
        </div>
      )}
      <div class="sstFooter type2">
        <div class="sstFooterCopyRight" id="sstFooterCopyRight">
          <span dir="ltr">
            © Inter IKEA Systems B.V. 1999-{new Date().getFullYear()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Home;
